import styled from 'styled-components'

export const Container = styled.footer`
  padding:1em;
  color: #fff;
  text-align: center;
  background: #3c4b4d;
  margin-top: 1em;
`

export const Text = styled.p`
  font-size: .9rem;
  font-weight:700;
  text-transform: uppercase;
`
